import React from 'react';
import { BrandDropDown, UserDropDown } from 'components';
import { Nav } from 'reactstrap';

import './header.scss';

export const Header = () => {
  return (
    <Nav className="header px-4 navbar bg-white shadow-sm">
      <BrandDropDown />
      <UserDropDown />
    </Nav>
  );
};
